﻿import { Component, ElementRef, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DataTable } from "angular2-datatable";
import { DataService } from "../services/dataService";



@Component({
    selector: "jax-docketscomponent",
    templateUrl: "./dockets.component.html"
})

export class DocketsComponent implements OnInit {
    public data;
    public sortBy = "FilingDate";
    public sortOrder = "desc";
    public rowsOnPage = 10;
    private userID: number;
    private currentUser: any;
    public totalRecord = 0;
    public isCompleted = false;
    public validationMessage = "";
    @Input() caseId: number;


    public documentHistory: any = {};


    constructor(private dataService: DataService, private router: Router) {
    }

    public ngOnInit() {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
            this.userID = this.currentUser.UserId;
        }

        this.isCompleted = false;

        this.dataService.get("docket/dockets?caseId=" + this.caseId + "&userId=" + this.userID + "&accesLevel=" + 3).subscribe(
            (resp) => {
                this.data = resp;
                this.isCompleted = true,
                    this.totalRecord = this.data.length;
            },
            (error) => {
                this.validationMessage = error.message;
                this.isCompleted = true;
            });
    }

    public onSelectDocket(docketId: number, documentType: string, filingDate: string) {
        this.validationMessage = "";
        this.openPdf(docketId, documentType, filingDate);
    }

    private openPdf(docketId: number, documentType: string, filingDate: string): void {
        this.dataService.sharedService.openPopupWindow();
        this.dataService.getPdf("docket/docket?caseId=" +
            this.caseId +
            "&docketId=" +
            docketId +
            "&userId=" +
            this.userID +
            "&accessLevel=" +
            3).subscribe((res) => {
                console.log("restype - " + res.type);
                if (res.type === "html") {
                    this.validationMessage = "OnBase login failed - please contact CTS Technical Support.";
                    this.dataService.sharedService.closePopupWindow();
                } else {
                     this.dataService.sharedService.displayPdf(res,documentType + filingDate + ".pdf");
                }
            },
            (error) => {
                this.validationMessage = error.message;
                this.isCompleted = true;
                this.dataService.sharedService.closePopupWindow();
            });
    }
}
